import get from "lodash.get";

import AbstractApi from "services/cores/abstractApi";
import paths from "routes/paths";
import CommonUtils from "services/common/utils";
import XHTTP from "services/api/xhttp";

class ReportsApi extends AbstractApi {
  retrieveList = (filters = {}) => {
    const queryString = CommonUtils.buildQueryStringFromObject({
      ...filters,
    });

    return XHTTP(`${get(this.config, "paths.default", "")}?${queryString}`, {
      method: "get",
    });
  };
}

export default new ReportsApi({
  paths: {
    default: paths.api.reports.list,
  },
});
